import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {config_marketplace_orphans_template} from "../components/templates/config_marketplace_orphans_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";

declare var ko: any;
declare var page: any;


export class config_marketplace_orphans extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected configOrphans: config_marketplace_orphans_template;
    protected _isLeavePageWarningNeeded: boolean = true;

    public fillPage() {
        this.getOrphansConfigData();
    }

    buildContent(): Array<Element> {
        this.configOrphans = new config_marketplace_orphans_template("config_marketplace_orphans", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Marketplace Orphans Settings");

        return [this.configOrphans.build()];
    }

    protected getModuleName(): string {
        return "config_marketplace_orphans";
    }

    private getOrphansConfigData() {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/generalconfig/marketplace-orphans-settings/get/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetOrphansConfigDataReturn;
        this.XHRHdl.execute();
    }

    private onGetOrphansConfigDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                let response = responseParsed.data;
                obj.configOrphans.setOrphansSettings(response.providers, response.orphanConfigs);
            });
        }
    }

    protected saveOrphansSettings() {
        this.loadingIn(this.configOrphans.builtTemplate);
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/generalconfig/marketplace-orphans-settings/save/";
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.configOrphans.getOrphansSettings()));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = (function (req, obj) {
            return function () {
                obj.manageResponse(req, obj, function () {
                    let idBrand = obj.getVnAppZone().getApp().params.idBrand;
                    page.redirect("/brand/" + idBrand + "/config/marketplace-orphans/");
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Marketplace Orphans settings saved!");
                });
                obj.loadingOut(obj.configOrphans.builtTemplate);
            }
        });
        XHRHdl.execute();
    }

    protected cancelOrphansSettings() {
        this.backAction();
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Marketplace Orphans settings changes cancelled!");
    }

    protected backAction() {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page.redirect("/brand/" + idBrand + "/config/marketplace-orphans/");
    }
}



// WEBPACK FOOTER //
// ./js/modules/config_marketplace_orphans.ts